module.exports = __webpack_public_path__ + "img/die_glueckliche_organisation.b4e12ada.png";